import { Box, Icon } from '@chakra-ui/react'
import type { FC } from 'react'
import type { IconType } from 'react-icons'
import { Link } from 'react-router-dom'

import { Tooltip } from '@app/components/ui/tooltip'
import { METRIC_SOURCES } from '@app/lib/globals'
import type { CardSize } from '@app/types'
import type { MetricSource } from '@graphql/types'

interface Props {
  sourceName?: string
  metricSource?: Pick<MetricSource, 'errorMessage'>
  metricId: string
  icon?: IconType
  color?: string
  size?: CardSize
}

const CardSource: FC<Props> = ({
  sourceName,
  metricSource = null,
  metricId,
  icon: iconOverride,
  color: colorOverride,
  size = 'normal'
}) => {
  const { icon, color, display } = METRIC_SOURCES[sourceName] || {}

  if (!sourceName) {
    return null
  }

  const boxSize = size === 'large' ? 6 : 4
  const IconComponent = iconOverride || icon

  const iconColor = metricSource?.errorMessage ? 'fg.error' : colorOverride || color
  const tooltipDisplay = metricSource?.errorMessage || display

  return (
    <Tooltip content={tooltipDisplay} showArrow>
      {/* this span lets the tooltip sit on the element and not push it around on the card */}
      <Box mx={2} style={{ display: 'flex' }}>
        <Link to={`metric/${metricId}/source`}>
          <Icon boxSize={boxSize} m={0} p={0} color={iconColor}>
            <IconComponent />
          </Icon>
        </Link>
      </Box>
    </Tooltip>
  )
}

export default CardSource
